import { Controller } from '@hotwired/stimulus'
import { opensAfterArm } from '../lib/armed_room_picker_rows'

// Bulk room selection: ticking rooms in the open menu only stages them, so the
// expert can pick several rooms without one ML redimensioning per click. The
// staged selection is applied once, when the menu closes (Apply button or a
// click outside), and only if it differs from the selection it opened with.
export default class extends Controller {
  static targets = ['checkbox', 'attributed']

  connect () {
    this.appliedSelection = this.#currentSelection()

    this.openIfArmedOnMorph = (event) => {
      if (event.target === this.element) this.#openIfArmed()
    }
    document.addEventListener('turbo:morph-element', this.openIfArmedOnMorph)
    this.#openIfArmed()
  }

  disconnect () {
    document.removeEventListener('turbo:morph-element', this.openIfArmedOnMorph)
  }

  stage (event) {
    event.stopPropagation()
  }

  apply () {
    if (this.#currentSelection() === this.appliedSelection) return

    this.appliedSelection = this.#currentSelection()
    if (this.hasAttributedTarget) {
      this.attributedTarget.value = 'true'
    }
    this.dispatch('refresh', { prefix: 'scenario_form' })
  }

  remove ({ params: { roomId } }) {
    const checkbox = this.checkboxTargets.find((input) => input.value === String(roomId))
    if (!checkbox) return

    checkbox.checked = false
    this.apply()
  }

  #openIfArmed () {
    const fieldName = this.checkboxTargets[0]?.name
    if (!fieldName) return

    const opens = opensAfterArm({
      formAction: this.element.closest('form')?.getAttribute('action'),
      fieldName,
      visible: this.element.offsetParent !== null,
      selectable: this.checkboxTargets.some((input) => !input.disabled)
    })
    if (opens) this.dispatch('open')
  }

  #currentSelection () {
    return this.checkboxTargets
      .filter((input) => input.checked)
      .map((input) => input.value)
      .sort()
      .join(',')
  }
}
